export const NODE_NAME = 'table';
